import type { Dispatch } from 'react';
import { createContext } from 'react';

import defaultSession from './SessionDefault';

import type SessionType from './SessionType';
import type SessionAction from './SessionAction';
import type Member from '@/types/member/member';
import type { JWTPayload } from '@/utils/string';
import type { RoleType } from '@/hooks/useNeedRole';

export interface SessionContextType {
  session: SessionType;
  dispatch: Dispatch<SessionAction>;
  userEmail: string | null;
  roles: RoleType[];
  me?: Member;
  parsedJwt: JWTPayload | null;
  isAdmin: boolean;
  isSiteManager: boolean;
  isSupport: boolean;
  isReport: boolean;
  hasSupportAccess: boolean;
}

export const SessionContext = createContext<SessionContextType>({
  session: defaultSession,
  dispatch: () => null,
  userEmail: null,
  roles: [],
  me: undefined,
  parsedJwt: null,
  isAdmin: false,
  isSiteManager: false,
  isSupport: false,
  isReport: false,
  hasSupportAccess: false,
});
